































import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import S3Image from '@/components/S3Image.vue';
import Card from '@/components/material/Card.vue';

@Component({
  components: {
    Card,
    S3Image,
  },
})
export default class UsersList extends Vue {
  private loading: boolean = false;

  @Action('admin/users/read') private readUsers!: () => Promise<boolean>;
  @Getter('admin/users/all') private users2!: any[];
  @Getter('admin/users/extracted') private users!: any[];

  private headers: any = [
    {
      text: 'Name',
      align: 'left',
      value: 'given_name',
    },
    {
      text: 'Email',
      align: 'left',
      sortable: true,
      value: 'email',
    },
    {
      text: 'Status',
      align: 'left',
      sortable: true,
      value: 'UserStatus',
    },
    {
      text: '# Subscriptions',
      align: 'left',
      sortable: true,
      value: 'subscriptions',
    },
    {
      text: '',
      align: 'left',
      sortable: false,
      value: '',
    },
  ];

  private mounted() {
    this.loading = true;

    this.readUsers()
      .then((success) => {
        if (success) {
          this.loading = false;
        } else {
          throw new Error('Some Error, handle it');
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  }
}
